import Edit from './edit/EditChannelVideo';
import Individual from './individual/ChannelVideo';

export default { Individual, Edit };
